import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeIcon'
})
export class TypeIconPipe implements PipeTransform {

  transform(t: string): string {

    let res: string;

    switch (
    t
    ) {
      case "folder":
        res = "folder";
        break;

      case "pdf":
        res = "picture_as_pdf";
        break;

      case "file":
        res = "insert_photo";
        break;

      case "quiz":
        res = "assignment";
        break;

      case "web":
        res = "http";
        break;

        case "file":
          res = "Fichier";
          break;

      default:
        break;
    }

    return res;
  }


}
